<script lang="ts" setup>
import IconMoinLogo from '@/svg/IconMoinLogo.vue';



const hostname = window.parent.location.href.split('/')[2];
</script>

<template>
  <a
    target="_blank"
    rel="nofollow"
    class="knw_widget_operator_poweredby"
    :href="`https://www.moin.ai/?utm_source=kunde&utm_medium=chatbot&utm_campaign=${hostname}`"
  >
    <span>Powered by</span>
    <IconMoinLogo />
  </a>
</template>

<style scoped lang="scss">
.knw_widget_operator_poweredby {
  margin: 0 auto;
  font-style: italic;
  padding-right: 5px;
  font-weight: 400;
  padding-top: 3px;

  /* Optically center the logo between the bottom of widget and the input field */
  transform: translateY(3px);


  svg {
    fill: var(--moin-powerdby-textcolor);
  }

  span {
    color: var(--moin-powerdby-textcolor);
    margin-right: 4px;
    line-height: 13px;
    font-size: 1rem;
    align-self: baseline;
  }

  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;

  &:hover {
    span {
      color: var(--moin-powerdby-textcolor-hover);
    }

    svg {
      fill: var(--moin-powerdby-textcolor-hover);
    }
  }

}
</style>
